import { Flex, Text } from '@chakra-ui/react';
import { Checkbox } from '@morressier/alembic';
import { Controller, Control } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { FieldFormValues } from '../../../helpers/articleTypeConfig.types';

type Props = {
  control: Control<FieldFormValues>;
  isFormDisabled: boolean;
  isMandatoryFieldSelected: boolean;
  currentDependentField?: string;
};

const RequiredAndDependentSection: React.FC<Props> = ({
  control,
  isFormDisabled,
  isMandatoryFieldSelected,
  currentDependentField
}) => {
  return (
    <Flex direction="row" gap={3}>
      <Flex gap={2} flex={1}>
        <FieldLabel label="Is Required" subText="" isRequired={false} />
        <Controller
          name="required"
          control={control}
          render={({ field }) => (
            <Checkbox
              id="required"
              name={field.name}
              ariaLabel="Field required"
              isChecked={Boolean(field.value)}
              onChange={event => field.onChange(event.target.checked)}
              disabled={isFormDisabled || isMandatoryFieldSelected}
            >
              {''}
            </Checkbox>
          )}
        />
      </Flex>

      {currentDependentField ? (
        <Flex direction="column" gap={2} flex={1}>
          <FieldLabel label="Dependent Field" subText="" isRequired={false} />
          <Text textStyle="textBody">{currentDependentField}</Text>
        </Flex>
      ) : null}
    </Flex>
  );
};

export default RequiredAndDependentSection;
